import { signDocument } from '../../graphql/mutations';
import {
  SET_SIGNED_APPROVAL_DOC_REQUESTED,
  SET_SIGNED_APPROVAL_DOC_COMPLETED,
  SET_SIGNED_APPROVAL_DOC_FAILED,
} from './types';
import api from '../../services/api';
import debug from '../../services/debug';

/**
 * Sign approval document
 *
 * @param {string} approvalDocId - Document id to approve
 * @param {string=} contactId - Optional contact ID to set signature
 * @param {string} [authMode=userPool] - Authentication mode to use for request
 */
const setSignedApprovalDocAction =
  (approvalDocId, contactId, authMode = 'userPool') =>
  async (dispatch, getState) => {
    // Ignore repeat submits while a sign request is already in flight.
    if (getState?.().approvaldocs?.get('signingApprovalDocs')?.loading) {
      return;
    }

    dispatch({
      type: SET_SIGNED_APPROVAL_DOC_REQUESTED,
    });

    try {
      const { data } = await api.graphql({
        authMode,
        query: signDocument,
        variables: {
          ContactID: contactId,
          input: {
            approvalDocId,
          },
          ...(contactId
            ? {
                resourceId: approvalDocId,
              }
            : {}),
        },
      });

      debug('data', data.signDocument);

      const payload = {
        data: data.signDocument,
      };

      dispatch({
        type: SET_SIGNED_APPROVAL_DOC_COMPLETED,
        payload,
      });
    } catch (err) {
      debug(SET_SIGNED_APPROVAL_DOC_FAILED, err);

      dispatch({
        type: SET_SIGNED_APPROVAL_DOC_FAILED,
        payload: err,
      });
    }
  };

export default setSignedApprovalDocAction;
